import { Course } from '../../../types/course'
import { formatDate } from '../../../utils/numbersFormatting'

interface CourseItemProps {
  course: Course
}

export default function CourseItem({ course }: CourseItemProps) {
  return (
    <div className="[&:not(:last-child)]:pb-8 [&:not(:last-child)]:mb-8 [&:not(:last-child)]:border-b border-gray-200">
      <div className="flex gap-4">
        <img
          src={`https://logo.clearbit.com/${course.institution.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')}.com`}
          alt={course.institution}
          className="w-12 h-12 rounded object-contain bg-gray-50"
          onError={e => {
            const target = e.target as HTMLImageElement
            target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(course.institution)}&background=random`
          }}
        />
        <div>
          <h3 className="text-lg font-semibold text-white-900">
            {course.title}
          </h3>
          <p className="text-white-700">{course.institution}</p>
          <p className="text-sm text-white-500">
            Issued {formatDate(course.completionDate * 1000)}
          </p>
          {course.description && (
            <p className="mt-2 text-white-700">{course.description}</p>
          )}
          {course.url && (
            <a
              href={course.url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-block text-blue-600 hover:text-blue-700"
            >
              Show credential
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
